import { Button } from "react-bootstrap";
import CustomModal from "../../components/customModal/CustomModal";

interface SessionExpiredModalProps {
  onClose: () => void;
}

const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({ onClose }) => {
  return (
    <CustomModal
      id="session-expired-modal"
      title="Session Expired"
      overlayClass="session-expired-overlay"
      content={
        <div className="modal--content--wrapper">
          <i
            className="bi bi-clock-history"
            style={{ fontSize: "48px", color: "#dc3545" }}
          ></i>
          <h5>Your session has expired</h5>
          <p>
            You have been logged out due to inactivity. Please sign
            in again to continue.
          </p>
          <div className="modal--action--btn--wrapper">
            <Button
              type="button"
              variant="primary"
              onClick={onClose}
            >
              OK
            </Button>
          </div>
        </div>
      }
      onClose={onClose}
    />
  );
};

export default SessionExpiredModal;
